import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=271a300c&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271a300c')) {
      api.createRecord('271a300c', component.options)
    } else {
      api.reload('271a300c', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=271a300c&", function () {
      api.rerender('271a300c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-form/components/Form.vue"
export default component.exports